import { useMutation, useQueryClient } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { apiClient } from '@/components/api';
import type { IPromotion } from '@/interfaces';
import { PromotionStatusEnum } from '@/enums';
import routes from '@/lib/routes';

type TParams = {
	onSuccess?: () => void;
};

type TVariables = {
	id: string;
	status: PromotionStatusEnum;
};

export const useRequestUpdatePromotionStatus = (params?: TParams) => {
	const queryClient = useQueryClient();
	const { isPending, error, mutateAsync } = useMutation({
		mutationFn: ({ id, status }: TVariables) =>
			apiClient
				.put<IPromotion>(routes.api.promotions.updateStatus(id), { status })
				.then(handleApiResponse),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [routes.api.promotions.base] });
			params?.onSuccess?.();
		},
	});

	return {
		isLoading: isPending,
		triggerUpdatePromotionStatus: (data: TVariables) => mutateAsync(data),
		error,
	};
};
